import { defineStore } from 'pinia'
import { router } from '../app';

//TODO: Search header/title; Prettier previews; Discuss pages vs components
export const useContentLibrary = defineStore('content-library', {
    state: () => {
        return {
            categorySlug: null,
            subcategorySlug: null,
            searchContent: '',
            sort: null,
            filters: {},
            page: null,
            contentMode: false,
            isModal: false,
            modalOpen: false,
            contents: [],
            pages: [],
            myContent: false,
            myContentFolder: null,
            language: null
        }
    },

    getters: {
        routeParams(state) {
            return {category: this.categorySlug, subcategory: this.subcategorySlug};
        },
    },

    actions: {
        switchContentMode(category, subcategory, search, sort, filters, page, myContent, folder) {
            if (category !== undefined && category !== null && category.trim() !== '') {
                this.categorySlug = category;
            } else {
                this.categorySlug = null;
            }

            if (subcategory !== undefined && subcategory !== null && subcategory.trim() !== '') {
                this.subcategorySlug = subcategory;
                this.contentMode = true;
            } else {
                this.subcategorySlug = null;
                this.contentMode = false;
            }

            if (search !== undefined && search.trim() !== '') {
                this.searchContent = search;
                this.contentMode = true;
            } else if (this.categorySlug == null) {
                this.searchContent = '';
                this.contentMode = false;
            } else {
                this.searchContent = '';
            }

            //Sorting and filtering are only possible if we already are in contentMode. Otherwise, ignore.
            if (sort !== undefined) {
                this.sort = sort;
                this.contentMode = true;
            } else {
                this.sort = null;
            }

            if (filters !== undefined) {
                this.filters = filters;
            } else {
                this.filters = {};
            }

            if (page !== undefined) {
                this.page = page;
            } else {
                this.page = null;
            }

            if (myContent !== undefined) {
                this.myContent = myContent;
            } else {
                this.myContent = false;
            }

            if (folder !== undefined) {
                this.myContentFolder = folder;
            } else {
                this.myContentFolder = null;
            }
        },

        search(searchPhrase) {
            if (searchPhrase && searchPhrase.trim() != '' && !this.contentMode) {
                this.contentMode = true;
            }

            this.goToSearch(searchPhrase);
        },

        goToSearch(searchPhrase) {
            if (this.isModal) {
                this.switchContentMode(
                    this.categorySlug,
                    this.subcategorySlug,
                    searchPhrase,
                    this.sort,
                    this.filters,
                    undefined //page
                );
                return;
            }

            let query;
            if (searchPhrase && searchPhrase.trim() != '') {
                query = {...router.currentRoute.value.query, ...{search: searchPhrase}};
                delete query.page;
                router.push({query: query});
            } else {
                query = {...router.currentRoute.value.query};
                delete query.search;
                delete query.page;
                router.push({query: query});
            }
        },

        sortBy(sort) {
            if (sort == '-') {
                sort = null;
            }
            if (this.isModal) {
                this.switchContentMode(
                    this.categorySlug,
                    this.subcategorySlug,
                    this.searchContent,
                    sort,
                    this.filters,
                    this.page
                );
                return;
            }

            let query;
            if (sort) {
                query = {...router.currentRoute.value.query, ...{sort: sort}}
                router.push({query: query});
            } else {
                query = {...router.currentRoute.value.query};
                delete query.sort;
                router.push({query: query});
            }
        },

        filter(filters) {
            let queryFilters = {};

            Object.entries(filters).forEach((filter) => {
                queryFilters[filter[0]] = [];
                Object.entries(filter[1]).forEach((item) => {
                    if (item[1].value) {
                        queryFilters[filter[0]].push(item[0]);
                    }
                });
            });

            if (this.isModal) {
                this.switchContentMode(
                    this.categorySlug,
                    this.subcategorySlug,
                    this.searchContent,
                    this.sort,
                    queryFilters,
                    undefined //page
                );
                return;
            }

            let query;
            if (Object.keys(queryFilters).length>0) {
                query = {...router.currentRoute.value.query, ...queryFilters};
                delete query.page;
                router.push({query: query});
            } else {
                query = {...router.currentRoute.value.query};
                delete query.filters;
                delete query.page;
                router.push({query: query});
            }
        },

        goToPage(page) {
            if  (page.url == null) {
                return;
            }

            let params = new URLSearchParams(page.url.split('?')[1]);

            let pageNumber = 0;

            for (let pair of params.entries()) {
                if (pair[0] == 'page') {
                    pageNumber = pair[1];
                }
            }

            if (this.isModal) {
                this.switchContentMode(
                    this.categorySlug,
                    this.subcategorySlug,
                    this.searchContent,
                    this.sort,
                    this.filters,
                    pageNumber
                );
                return;
            }

            let query;
            if (pageNumber) {
                query = {...router.currentRoute.value.query, ...{page: pageNumber}}
                router.push({query: query});
            } else {
                query = {...router.currentRoute.value.query};
                delete query.page;
                router.push({query: query});
            }

            this.scrollToTop();
        },

        goToRoot() {
            if (this.isModal) {
                this.switchContentMode(
                    undefined, //categorySlug
                    undefined, //subcategorySlug
                    undefined, //search
                    undefined, //sort
                    undefined, //filters
                    undefined //page
                );
            } else {
                router.push({ name: 'content library' });
            }
        },

        goTo(categorySlug, subcategorySlug) {
            if (this.isModal) {
                this.switchContentMode(
                    categorySlug,
                    subcategorySlug,
                    undefined, //search
                    undefined, //sort
                    undefined, //filters
                    undefined //page
                );

                return;
            }

            if (subcategorySlug === null) {
                router.push({ name: 'content library', params: {category: categorySlug}});
            } else {
                router.push({ name: 'content library', params: {category: categorySlug, subcategory: subcategorySlug}});
            }
        },

        goToMyContent() {
            if (this.isModal) {
                this.switchContentMode(
                    undefined, //categorySlug
                    undefined, //subcategorySlug
                    undefined, //search
                    undefined, //sort
                    undefined, //filters
                    undefined, //page,
                    true       //myContent
                );

                return;
            }

            router.push({ name: 'my content' });
        },

        goToMyContentFolder(folder) {
            if (this.isModal) {
                this.switchContentMode(
                    undefined, //categorySlug
                    undefined, //subcategorySlug
                    undefined, //search
                    undefined, //sort
                    undefined, //filters
                    undefined, //page,
                    true,      //myContent
                    folder     //myContentFolder
                );

                return;
            }

            router.push({ name: 'my content', params: {folder: folder} });
        },

        scrollToTop() {
            if (! this.isModal) {
                window.scrollTo(0,0);
            }
        },

        resetContentLibrary() {
            let language = this.language;

            this.$reset();

            if (language !== null) {
                this.language = language;
            }
        }
    }
})
